module.exports = __webpack_public_path__ + "img/header-engagementRingsEssentials.892ab5e.webp";